import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { User } from './user.model';
import { UserStore } from './user.store';

@Injectable({ providedIn: 'root' })
export class UserService {

  constructor(
    private userStore: UserStore,
    private http: HttpClient
  ) {
  }

  get() {
    return this.http.get<User>('/api/userinfo/').pipe(tap(user => {
      this.userStore.update({ user });
    }));
  }

}
